import React from "react";

const HomeAbout = () => {
  return (
    <div className="flex flex-col md:flex-row justify-center items-center gap-10 mt-10 w-[90vw] md:w-[80vw] mx-auto">
      {/* Left: Image Gallery */}
      <div className="w-full md:w-1/2 grid grid-cols-2 gap-4">
        <img
          src="https://i.ibb.co/nN3X1gCW/Factory2.jpg"
          alt="Perfume 1"
          className="w-full h-[150px] sm:h-[250px] object-cover rounded-lg shadow-md"
        />
        <img
          src="https://i.ibb.co/sdndxFvp/FACTORY1.jpg"
          alt="Perfume 2"
          className="w-full h-[150px] sm:h-[250px] object-cover rounded-lg shadow-md"
        />
        <img
          src="https://i.ibb.co/p6H4K7TL/factory5.jpg"
          alt="Perfume 3"
          className="w-full h-[150px] sm:h-[250px] object-cover rounded-lg shadow-md"
        />
        <img
          src="https://i.ibb.co/G3kpQYK5/factory4.jpg"
          alt="Perfume 4"
          className="w-full h-[150px] sm:h-[250px] object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Right: Text Content */}
      <div className="w-full md:w-1/2 sm:text-center md:text-left">
        <p className="text-3xl sm:text-5xl my-6 text-[#035A6F] font-bold">
          NEXTCARE PERFUMES & COSMETICS
        </p>
        <p className="text-lg md:text-xl mb-4 text-black">
          As a perfume and cosmetics manufacturer, Nextcare offers full services
          for third parties & contract manufacturing.
        </p>
        <p className="text-base md:text-lg text-black text-opacity-70">
          In life, it's not just about what you do, but how you do it, and, above
          all, who you do it with. That's what really sets us apart: We are
          full-service perfume and cosmetics manufacturers, taking care of every
          detail, with a great team of professionals who direct and design the
          entire process, so that you feel supported and have the assurance that
          you have chosen the best solution.
        </p>
      </div>
    </div>
  );
};

export default HomeAbout;
